export const LOGIN_BASE =
  process.env.REACT_APP_LOGIN_BASE_URL || "https://fso-api.freemansgroup.com";
